import { Link, NavLink } from "react-router-dom";

// Inventory Stock

export default function Navbar() {
    return (
        <nav className="navbar navbar-expand-md navbar-dark bg-success">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">Stock Manager</Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarContent" aria-controls="navbarContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon" />
                </button>
                <div className="collapse navbar-collapse" id="navbarContent">
                    <ul className="nav nav-pills">
                        <li className="nav-item">
                            <NavLink exact to="/" className="nav-link text-white">Home</NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink to="/products" className="nav-link text-white">Products</NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink to="/in" className="nav-link text-white">Product IN</NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink to="/out" className="nav-link text-white">Product OUT</NavLink>
                        </li>

                        <li className="nav-item">
                            <NavLink to="/transactions" className="nav-link text-white">Transactions</NavLink>
                        </li>

                        {/* <li className="nav-item">
                            <NavLink to="/sales" className="nav-link text-white">Product OUT</NavLink>
                        </li> */}
                    </ul>
                </div>
            </div>
        </nav>
    );
}
